import React from 'react'

const Version = () => {
  return <div>{`${process.env.VERSION}`}</div>
}

export default Version
